import { CustomCellRendererProps } from 'ag-grid-react'

import { toISO8601 } from '@fortem-monorepo/js-utilities'

export interface DateCellRendererProps extends CustomCellRendererProps {
  value: Date | null
}

export const DateCellRenderer: React.FC<DateCellRendererProps> = ({ value }) => {
  return <>{value ? toISO8601(value) : value}</>
}
